import { render, staticRenderFns } from "./FileSummary.vue?vue&type=template&id=6ff6c9d9"
import script from "./FileSummary.vue?vue&type=script&lang=ts"
export * from "./FileSummary.vue?vue&type=script&lang=ts"
import style0 from "./FileSummary.vue?vue&type=style&index=0&id=6ff6c9d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports